<ng-container [ngSwitch]="version">
	<ng-container *ngSwitchCase="0">
		<div>
			<div class="ussd">
				<div class="icon-ussd">
					<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
							fill="#0361F0"/>
					</svg>
				</div>
				<div>
					<div class="ml-[9px]">
						<div *ngIf="isBvnUssd ; else nonBvnUssd">
							<div class="ussd-note">
                                <span> Dial <span>
                                        <span (click)="lunchDialer(BVN_USSD)" class="ussd-value">*565*0#</span>
                                    </span> on your registered phone number to get your BVN </span>
							</div>
						</div>
						<ng-template #nonBvnUssd>
							<div class="ussd-note">
                                <span>
                                    Didn’t get the code? Dial <span class="ussd-value">
                                        <span (click)="lunchDialer(ussdCode)">
                                            {{ussdCode}}
                                        </span>
                                    </span>
                                </span>
							</div>
						</ng-template>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="1">

		<div class="ussd">
			<div class="icon-ussd">
				<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
						fill="#0361F0"/>
				</svg>
			</div>
			<div>
				<div class="ml-[9px]">
					<div>
						<div class="ussd-note">
                            <span>
                               Didn't get the code? 
							   <button class="text-[#0361F0] cursor-pointer font-normal disabled:text-[#999999]" [disabled]="showResendButtonCountDown">
                                    <span (click)="launchOtpModalBoard()">
                                       Resend OTP
                                    </span>
									<ng-container *ngIf="showResendButtonCountDown">
										<span class="inline-flex">
											(<span>
												{{formatTime(countdown?.minutes)}}
											</span>
											<span>:</span>
											<span>
												{{formatTime(countdown?.seconds)}}
											</span>)
										</span>
									</ng-container>
                                </button>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-container>

